import { useMemo } from 'react'

import { HeadingDisplayBlock as HeadingDisplayBlockType } from '../../types/blueprint'

import { Text, TextProps } from '@/components/shared-components/BUI/Text'

const getLevel = (
  size: HeadingDisplayBlockType['size']
): TextProps['variant'] => {
  switch (size) {
    case 'H1':
      return 'heading01'
    case 'H2':
      return 'heading02'
    case 'H3':
      return 'heading03'
    case 'H4':
      return 'heading04'
    case 'H5':
      return 'subheading01'
    default:
      return 'heading01'
  }
}

type Props = {
  block: HeadingDisplayBlockType
}

export const HeadingDisplayBlock: React.FC<Props> = ({ block }) => {
  const variant = useMemo(() => getLevel(block.size), [block.size])

  return <Text variant={variant}>{block.content}</Text>
}
